var React = require('react');

function StrokeMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M540.281,57.759c-21.859,59.833-197.912,103.508-193.807,131.386,6.955,47.24,126.918,8.917,34.266-29.546s-276.1,67.762-284.16,70.448S1.861,166.743,8.094,165.4s155-21.5,163.061-13.436S188.348,258.416,181.9,266.168c-6.72,8.086-153.983,26.852-166.561,16.1S-2.625,199.2,1.623,180.329","transform":"translate(0.555 -57.587)","fill":"none","stroke":"#fff","strokeWidth":"1"}));
}

StrokeMail.defaultProps = {"width":"541.305","height":"228.426","viewBox":"0 0 541.305 228.426"};

module.exports = StrokeMail;

StrokeMail.default = StrokeMail;
